import React from "react";
import AdditionalChargesApply from "../../../../../shared/AdditionalCharges/AdditionalChargesApply";
import { numberFormat } from "../../../../../Utils";

export function ModalRescheduleFee({ onClose, fee, onReschedule }) {
  return (
    <>
      <div className="overlay"></div>
      <div
        id="filterModal"
        role="dialog"
        className="modal fade in displayBlock"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={onClose}
              >
                ×
              </button>
              <h4 className="modal-title" id="model_title">
                Rescheduling Fee
              </h4>
            </div>
            <div
              id="errorwindow"
              className="modal-body add-patient-form filter-patient"
            >
              {"There is a rescheduling fee of "}{" "}
              {numberFormat(fee, "currency")}. What do you want to do?
              <AdditionalChargesApply />
            </div>
            <div className="modal-footer">
              <div className="col-md-12 text-left" id="footer-btn">
                <button
                  type="button"
                  className="btn btn-success pull-right"
                  data-charge={true}
                  onClick={onReschedule}
                >
                  {"Save & Charge"}
                </button>
                <button
                  type="button"
                  className="btn  logout pull-right m-r-10"
                  data-charge={false}
                  onClick={onReschedule}
                >
                  {"Save & Do Not Charge"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
